// Single source of truth for survey question types.
// Imported by the creator (survey-questionnaire-form, questions-form), the
// read-only editor view (question-component) and the shared runner (survey-runner).
// Add a new question type here once and every surface picks it up.

// `value` is persisted — never change it. `label`, `description` and `icon` are display only.
export const QUESTION_TYPES = [
    { value: 'customOptions', label: 'Single choice', description: 'Pick one answer from a list', icon: 'single', hasOptions: true },
    { value: 'hybrid-customOptions', label: 'Single choice + Other', description: 'Pick one, or type their own answer', icon: 'single', hasOptions: true },
    { value: 'checkbox', label: 'Multiple choice', description: 'Tick all answers that apply', icon: 'multi', hasOptions: true },
    { value: 'hybrid-checkbox', label: 'Multiple choice + comment', description: 'Tick all that apply, plus a comment', icon: 'multi', hasOptions: true },
    { value: 'scale5', label: 'Scale 1–5', description: 'Rate from 1 to 5', icon: 'scale', hasOptions: false },
    { value: 'scale10', label: 'Scale 1–10', description: 'Rate from 1 to 10 (NPS style)', icon: 'scale', hasOptions: false },
    { value: 'rating', label: 'Star rating', description: 'Rate with stars (3–10)', icon: 'star', hasOptions: false, hasStars: true },
    { value: 'matrix-scale5', label: 'Grid (rate several items)', description: 'Rate a list of items, each 1–5', icon: 'grid', hasOptions: false, hasItems: true },
    { value: 'comment', label: 'Free text', description: 'Open comment box', icon: 'text', hasOptions: false },
];

const findType = (type) => QUESTION_TYPES.find((t) => t.value === type);

// Does this type require the author to supply answer options?
export const typeNeedsOptions = (type) => !!findType(type)?.hasOptions;

// Human readable label for a type value.
export const typeLabel = (type) => findType(type)?.label ?? type;

// Runner-side validation: has the current question been answered well enough to advance?
// Keeps the matrix / optional rules in one place instead of inside each runner.
export const isQuestionAnswered = (question, answer) => {
    if (!question) return true;
    if (question.optional === true) return true;

    if (question.type === 'matrix-scale5') {
        const itemsCount = question.items?.length || 0;
        const answeredCount = answer ? Object.keys(answer).length : 0;
        return answeredCount >= itemsCount;
    }

    return answer !== undefined && answer !== null && answer !== '';
};
